import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { loginWithGoogle } from '@/services/auth-service';
import { useAuth } from '@/contexts/AuthContext';
import { useToast } from '@/hooks/use-toast';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();   // ← puxa a função login do contexto
  const { toast } = useToast();

  const handleSuccess = async (credentialResponse: CredentialResponse) => {
    try {
      if (!credentialResponse.credential) {
        throw new Error('Credencial do Google não encontrada');
      }

      const response = await loginWithGoogle(credentialResponse.credential);

      if (!response.access_token) {
        throw new Error('Token de acesso não retornado');
      }

      // Passa o profile completo (com permissions[] e level) pro contexto
      login(response.access_token, response.user);

      toast({
        title: "Login realizado com sucesso!",
        description: "Bem-vindo à Odonto Inclusiva",
      });

      navigate('/');
    } catch (error) {
      toast({
        title: "Erro ao fazer login",
        description: error instanceof Error ? error.message : "Tente novamente mais tarde",
        variant: "destructive",
      });
    }
  };

  const handleError = () => {
    toast({
      title: "Erro ao fazer login",
      description: "Não foi possível autenticar com o Google",
      variant: "destructive",
    });
  };

  return (
    <div
      className="min-h-screen bg-cover bg-center flex items-center justify-center p-6"
      style={{
        backgroundImage: "url('/images/background-tech-inclusion.jpg')",
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <div className="bg-white/90 backdrop-blur-md rounded-xl max-w-lg w-full p-6 shadow-xl border border-gray-300">
        <header className="text-center mb-5">
          <img src="/images/logo-odonto-inclusiva-warm_wb.png" alt="Odonto Inclusiva" className="mx-auto w-auto mb-4 max-h-20" />
          <h1 className="text-3xl font-extrabold text-primary mb-1">Odonto Inclusiva</h1>
          <p className="text-primary/90 italic font-semibold text-xs max-w-xs mx-auto">
            Tecnologia com Propósito Social para a Odontologia
          </p>
        </header>

        <section className="mb-6 text-center">
          <p className="mb-2 text-gray-700 font-medium text-sm">
            Bem-vindo ao sistema que transforma o mercado odontológico.
          </p>
          <p className="text-gray-600 text-sm">
            Entre com o Google para acessar a sua plataforma de gestão.
          </p>
        </section>

        <section className="flex justify-center mb-8">
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleError}
            theme="filled_blue"
            size="large"
            text="continue_with"
            shape="pill"
            locale="pt-BR"
          />
        </section>

        <footer className="text-center text-xs text-gray-500 select-none">
          <p>Ao fazer login, você concorda com nossos <button className="underline hover:text-primary cursor-pointer">Termos de Uso</button> e <button className="underline hover:text-primary cursor-pointer">Política de Privacidade</button>.</p>
          <p className="mt-2">© 2025 Odonto Inclusiva. Todos os direitos reservados.</p>
        </footer>
      </div>
    </div>
  );
};

export default Login;